// extracted by mini-css-extract-plugin
export default {"container":"Header_container__Ma8KJ","title":"Header_title__NdmJG","description":"Header_description__SPwIr"};